/*
 * Copyright 2020 Spotify AB
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import React from 'react';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 30
  },
  path: {
    fill: '#7df3e1'
  }
});
const LogoFull = () => {
  const classes = useStyles();

  return (
    React.createElement('svg', { className: classes.svg, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 2079.95 456.05"   ,}
      , React.createElement('path', {
        className: classes.path,
        d: "M 183.00,7.00 C 185.87,1.26 192.95,-1.02 199.00,0.56 199.00,0.56 233.00,19.72 233.00,19.72 233.00,19.72 258.00,34.77 258.00,34.77 258.00,34.77 355.00,91.60 355.00,91.60 355.00,91.60 380.00,106.77 380.00,106.77 383.05,108.56 389.27,111.29 390.98,114.21 392.21,116.31 392.00,119.61 392.00,122.00 392.00,122.00 392.00,229.00 392.00,229.00 392.00,229.00 391.00,244.00 391.00,244.00 391.00,244.00 391.00,333.00 391.00,333.00 390.99,335.87 391.33,339.11 389.40,341.47 387.73,343.52 378.77,348.56 376.00,350.15 376.00,350.15 350.00,365.28 350.00,365.28 350.00,365.28 238.00,430.09 238.00,430.09 238.00,430.09 210.00,446.40 210.00,446.40 206.74,448.36 199.60,453.22 196.00,453.22 192.01,453.22 181.10,445.74 177.00,443.46 177.00,443.46 129.00,415.01 129.00,415.01 129.00,415.01 31.00,357.45 31.00,357.45 31.00,357.45 10.00,345.40 10.00,345.40 7.28,343.81 2.56,341.58 1.02,338.87 -0.20,336.72 0.00,333.43 0.00,331.00 0.00,331.00 0.00,109.00 0.00,109.00 8.83,106.73 32.71,91.54 41.58,86.09 41.58,86.09 49.57,81.92 49.57,81.92 49.57,81.92 58.09,76.51 58.09,76.51 58.09,76.51 70.83,70.05 70.83,70.05 70.83,70.05 79.75,64.42 79.75,64.42 79.75,64.42 92.59,57.02 92.59,57.02 92.59,57.02 119.83,41.84 119.83,41.84 124.22,39.69 127.11,36.49 132.00,36.00 134.60,32.01 139.60,30.51 143.53,28.02 143.53,28.02 153.28,21.95 153.28,21.95 153.28,21.95 163.75,16.38 163.75,16.38 168.69,13.21 177.28,7.44 183.00,7.00 Z M 304.00,104.00 C 298.66,103.10 282.98,92.69 277.54,89.43 277.54,89.43 250.43,73.92 250.43,73.92 250.43,73.92 236.68,65.10 236.68,65.10 236.68,65.10 227.08,59.92 227.08,59.92 227.08,59.92 202.83,46.25 202.83,46.25 199.38,45.54 192.37,45.94 189.09,47.26 185.75,48.60 184.76,50.41 181.00,51.00 177.42,55.60 175.39,55.27 170.59,58.06 170.59,58.06 160.84,64.05 160.84,64.05 160.84,64.05 149.32,70.10 149.32,70.10 149.32,70.10 140.57,75.92 140.57,75.92 140.57,75.92 104.08,96.56 104.08,96.56 97.69,100.37 85.46,108.46 79.00,110.00 79.00,110.00 80.00,112.00 80.00,112.00 72.72,113.19 57.92,123.18 51.08,127.41 48.65,128.91 41.51,132.22 40.29,133.83 38.70,135.92 39.00,139.48 39.00,142.00 39.00,142.00 39.00,307.00 39.00,307.00 39.00,309.15 38.81,312.57 39.82,314.46 41.04,316.71 46.58,319.53 48.92,320.94 48.92,320.94 71.00,335.00 71.00,335.00 74.67,335.62 78.18,338.55 81.43,340.45 87.24,343.86 94.81,346.61 99.00,352.00 103.88,352.83 119.68,362.92 124.66,366.07 124.66,366.07 133.00,370.61 133.00,370.61 133.00,370.61 145.42,378.40 145.42,378.40 145.42,378.40 156.72,384.59 156.72,384.59 156.72,384.59 167.92,391.94 167.92,391.94 167.92,391.94 188.01,403.30 188.01,403.30 189.71,403.88 191.24,403.93 193.00,403.98 205.12,404.34 209.13,399.16 219.01,393.98 219.01,393.98 262.03,370.46 262.03,370.46 262.03,370.46 277.72,361.95 277.72,361.95 277.72,361.95 314.85,341.54 314.85,341.54 314.85,341.54 330.07,332.66 330.07,332.66 330.07,332.66 344.91,324.87 344.91,324.87 347.23,323.68 351.35,321.80 352.72,319.59 354.21,317.17 354.00,312.80 354.00,310.00 354.00,310.00 354.00,143.00 354.00,143.00 353.98,132.61 350.54,132.61 340.25,126.42 340.25,126.42 317.75,113.03 317.75,113.03 313.02,110.26 307.78,108.04 304.00,104.00 Z M 194.00,388.00 C 189.62,383.97 182.61,381.10 177.29,378.06 177.29,378.06 157.29,366.06 157.29,366.06 157.29,366.06 123.70,345.46 123.70,345.46 123.70,345.46 85.33,322.50 85.33,322.50 85.33,322.50 61.16,308.64 61.16,308.64 59.61,307.66 53.74,304.33 52.99,303.31 51.74,301.59 52.00,298.08 52.00,296.00 52.00,296.00 52.00,154.00 52.00,154.00 52.02,143.78 53.35,145.02 67.83,136.92 67.83,136.92 111.95,111.53 111.95,111.53 111.95,111.53 122.59,104.92 122.59,104.92 122.59,104.92 131.41,100.50 131.41,100.50 131.41,100.50 140.29,94.94 140.29,94.94 140.29,94.94 161.43,82.56 161.43,82.56 161.43,82.56 168.58,78.83 168.58,78.83 168.58,78.83 186.92,68.06 186.92,68.06 189.64,66.43 193.94,63.28 197.09,63.30 201.18,63.33 210.02,68.97 213.54,71.34 213.54,71.34 228.75,80.05 228.75,80.05 228.75,80.05 239.18,86.87 239.18,86.87 239.18,86.87 259.59,98.50 259.59,98.50 263.22,100.58 267.68,102.44 270.00,106.22 270.00,106.22 272.83,106.22 272.83,106.22 272.83,106.22 288.15,115.17 288.15,115.17 288.15,115.17 290.00,118.00 290.00,118.00 290.00,118.00 302.17,123.84 302.17,123.84 302.17,123.84 310.99,128.21 310.99,128.21 310.99,128.21 323.16,135.88 323.16,135.88 323.16,135.88 340.02,146.68 340.02,146.68 340.02,146.68 341.00,154.00 341.00,154.00 341.00,154.00 341.00,299.00 341.00,299.00 341.00,299.00 339.83,307.59 339.83,307.59 339.83,307.59 330.27,313.62 330.27,313.62 330.27,313.62 321.83,318.52 321.83,318.52 321.83,318.52 315.28,321.63 315.28,321.63 315.28,321.63 308.03,326.14 308.03,326.14 308.03,326.14 257.17,353.95 257.17,353.95 257.17,353.95 226.17,371.10 226.17,371.10 226.17,371.10 194.00,388.00 194.00,388.00 Z M 948.00,374.00 C 948.00,374.00 948.00,127.00 948.00,127.00 948.01,119.75 948.90,112.23 952.97,106.00 959.19,96.47 972.80,93.63 983.00,97.95 991.91,101.73 1004.87,115.87 1012.00,123.00 1012.00,123.00 1107.00,218.00 1107.00,218.00 1107.00,218.00 1119.00,229.01 1119.00,229.01 1119.00,229.01 1186.00,296.00 1186.00,296.00 1186.00,296.00 1186.00,97.00 1186.00,97.00 1186.00,97.00 1233.00,97.00 1233.00,97.00 1233.00,97.00 1233.00,348.00 1233.00,348.00 1232.99,354.72 1232.38,361.10 1228.79,367.00 1222.02,378.11 1208.38,380.52 1197.00,375.47 1188.33,371.63 1176.03,358.03 1169.00,351.00 1169.00,351.00 1149.04,331.00 1149.04,331.00 1149.04,331.00 1139.00,320.00 1139.00,320.00 1139.00,320.00 995.00,176.00 995.00,176.00 995.00,176.00 995.00,374.00 995.00,374.00 995.00,374.00 948.00,374.00 948.00,374.00 Z M 501.00,99.00 C 501.00,99.00 659.00,99.00 659.00,99.00 691.03,99.00 724.93,96.35 754.00,112.31 780.64,126.94 794.11,153.75 797.71,183.00 797.71,183.00 798.82,198.00 798.82,198.00 799.08,201.63 798.32,203.55 797.96,207.00 797.96,207.00 797.96,216.00 797.96,216.00 796.62,228.49 791.96,244.23 785.55,255.00 774.76,273.13 762.15,282.75 743.00,291.00 743.00,291.00 797.00,345.00 797.00,345.00 797.00,345.00 825.00,374.00 825.00,374.00 825.00,374.00 763.00,374.00 763.00,374.00 763.00,374.00 756.00,373.40 756.00,373.40 756.00,373.40 741.09,359.00 741.09,359.00 741.09,359.00 701.09,315.00 701.09,315.00 701.09,315.00 684.83,298.60 684.83,298.60 684.83,298.60 678.00,298.00 678.00,298.00 678.00,298.00 584.00,298.00 584.00,298.00 584.00,298.00 584.00,255.00 584.00,255.00 584.00,255.00 680.00,255.00 680.00,255.00 697.84,255.00 715.57,256.87 731.00,245.96 748.52,233.57 750.22,214.48 750.00,195.00 749.86,183.51 745.73,171.50 737.83,163.04 726.93,151.37 710.35,148.02 695.00,148.00 695.00,148.00 550.00,148.00 550.00,148.00 550.00,148.00 550.00,374.00 550.00,374.00 550.00,374.00 501.00,374.00 501.00,374.00 501.00,374.00 501.00,99.00 501.00,99.00 Z M 851.00,99.00 C 851.00,99.00 900.00,99.00 900.00,99.00 900.00,99.00 900.00,374.00 900.00,374.00 900.00,374.00 851.00,374.00 851.00,374.00 851.00,374.00 851.00,99.00 851.00,99.00 Z M 1570.00,374.00 C 1570.00,374.00 1395.00,374.00 1395.00,374.00 1382.53,373.98 1366.59,370.39 1355.00,365.80 1329.44,355.67 1307.61,338.15 1292.70,315.00 1260.02,264.27 1262.15,185.07 1304.09,140.00 1325.58,116.90 1355.01,104.00 1386.00,100.10 1386.00,100.10 1396.00,100.10 1396.00,100.10 1396.00,100.10 1407.00,99.00 1407.00,99.00 1407.00,99.00 1443.00,99.00 1443.00,99.00 1443.00,99.00 1553.00,99.00 1553.00,99.00 1553.00,99.00 1553.00,148.00 1553.00,148.00 1553.00,148.00 1407.00,148.00 1407.00,148.00 1395.42,148.02 1381.67,150.30 1371.00,154.87 1362.49,158.52 1353.79,163.79 1347.00,170.09 1314.73,200.05 1310.39,252.84 1334.75,289.00 1338.73,294.91 1343.79,300.08 1349.00,304.91 1372.73,326.90 1399.10,326.00 1429.00,326.00 1429.00,326.00 1521.00,326.00 1521.00,326.00 1521.00,326.00 1521.00,255.00 1521.00,255.00 1521.00,255.00 1397.00,255.00 1397.00,255.00 1397.00,255.00 1397.00,214.00 1397.00,214.00 1397.00,214.00 1570.00,214.00 1570.00,214.00 1570.00,214.00 1570.00,374.00 1570.00,374.00 Z M 300.00,163.00 C 300.00,163.00 277.72,150.94 277.72,150.94 277.72,150.94 244.34,130.99 244.34,130.99 244.34,130.99 227.26,121.55 227.26,121.55 227.26,121.55 208.92,110.56 208.92,110.56 208.92,110.56 198.00,105.53 198.00,105.53 198.00,105.53 188.75,109.44 188.75,109.44 188.75,109.44 167.00,121.00 167.00,121.00 167.00,121.00 153.58,129.14 153.58,129.14 153.58,129.14 117.00,150.61 117.00,150.61 117.00,150.61 95.00,162.00 95.00,162.00 95.00,162.00 92.00,164.00 92.00,164.00 92.00,164.00 92.00,234.00 92.00,234.00 92.00,234.00 91.00,249.00 91.00,249.00 91.00,249.00 91.00,272.00 91.00,272.00 91.00,272.00 92.00,289.00 92.00,289.00 92.00,289.00 120.75,305.44 120.75,305.44 120.75,305.44 128.72,309.45 128.72,309.45 128.72,309.45 138.46,315.49 138.46,315.49 138.46,315.49 167.00,331.49 167.00,331.49 167.00,331.49 190.29,344.78 190.29,344.78 190.29,344.78 198.00,344.78 198.00,344.78 198.00,344.78 218.00,338.00 218.00,338.00 218.00,338.00 217.00,336.00 217.00,336.00 222.35,334.70 235.69,326.60 240.92,323.44 240.92,323.44 267.68,308.90 267.68,308.90 273.84,305.32 279.53,299.67 287.00,299.00 287.00,299.00 298.71,289.62 298.71,289.62 298.71,289.62 300.00,280.00 300.00,280.00 300.00,280.00 300.00,201.00 300.00,201.00 300.00,201.00 300.00,163.00 300.00,163.00 Z M 168.00,142.00 C 168.00,142.00 177.84,135.05 177.84,135.05 177.84,135.05 190.15,127.46 190.15,127.46 190.15,127.46 197.92,124.36 197.92,124.36 197.92,124.36 206.95,129.00 206.95,129.00 206.95,129.00 225.41,139.92 225.41,139.92 225.41,139.92 235.00,147.00 235.00,147.00 239.20,147.42 244.28,150.89 248.17,152.91 248.17,152.91 268.16,164.88 268.16,164.88 271.67,166.72 283.05,172.81 285.02,175.68 286.26,177.49 286.00,180.86 286.00,183.00 286.00,183.00 286.00,271.00 286.00,271.00 286.00,273.13 286.19,276.59 285.18,278.46 283.99,280.63 281.34,281.49 279.27,282.62 279.27,282.62 266.43,289.95 266.43,289.95 266.43,289.95 240.41,305.02 240.41,305.02 240.41,305.02 227.41,312.08 227.41,312.08 218.68,317.34 203.43,326.85 194.00,329.00 187.09,322.36 167.88,315.46 164.00,309.00 159.14,308.51 146.24,301.48 144.00,297.00 144.00,297.00 141.00,298.00 141.00,298.00 141.00,298.00 129.00,290.54 129.00,290.54 129.00,290.54 105.00,277.00 105.00,277.00 105.00,277.00 105.00,185.00 105.00,185.00 105.00,182.71 104.78,179.47 105.98,177.47 107.56,174.86 114.10,171.57 116.85,170.05 116.85,170.05 134.43,159.56 134.43,159.56 134.43,159.56 140.72,156.37 140.72,156.37 146.70,152.82 161.64,142.36 168.00,142.00 Z M 200.00,166.00 C 196.03,169.78 193.48,166.28 186.59,170.07 186.59,170.07 159.43,185.56 159.43,185.56 153.99,188.61 150.28,192.29 144.00,193.00 144.00,193.00 144.00,211.00 144.00,211.00 144.00,211.00 144.00,249.00 144.00,249.00 144.00,249.00 144.82,256.47 144.82,256.47 144.82,256.47 164.05,269.43 164.05,269.43 164.05,269.43 189.28,284.70 189.28,284.70 189.28,284.70 197.00,284.70 197.00,284.70 197.00,284.70 202.71,284.70 202.71,284.70 202.71,284.70 227.00,270.90 227.00,270.90 227.00,270.90 246.83,258.59 246.83,258.59 246.83,258.59 248.00,250.00 248.00,250.00 248.00,250.00 248.00,202.00 248.00,202.00 248.00,202.00 247.02,194.18 247.02,194.18 247.02,194.18 238.00,187.56 238.00,187.56 238.00,187.56 228.58,181.63 228.58,181.63 228.58,181.63 216.00,174.00 216.00,174.00 216.00,174.00 200.00,166.00 200.00,166.00 Z"
















































































































































































































































































                ,}
      )
    )
  );
};

export default LogoFull;
